export default "__VITE_ASSET__DqG3UEyl__"